export default __webpack_public_path__ + "static/lab-visit-female-953b8411defac74517b2891fd9befead.jpg";